// Right-click blocking functionality

const rightClickBlock = true;

if (rightClickBlock) {
  // // Block right-click context menu
  // document.addEventListener('contextmenu', function(e) {
  //     e.preventDefault();
  //     return false;
  // });

  // // Block text selection
  // document.addEventListener('selectstart', function(e) {
  //     e.preventDefault();
  //     return false;
  // });

  // // Block drag and drop
  // document.addEventListener('dragstart', function(e) {
  //     e.preventDefault();
  //     return false;
  // });

  // // Block copy shortcuts (Ctrl+C, Cmd+C)
  // document.addEventListener('keydown', function(e) {
  //     // Check for Ctrl+C or Cmd+C
  //     if ((e.ctrlKey || e.metaKey) && e.key === 'c') {
  //         e.preventDefault();
  //         return false;
  //     }

  //     // Check for F12 (developer tools)
  //     if (e.key === 'F12' || e.keyCode === 123) {
  //         e.preventDefault();
  //         return false;
  //     }

  //     // Check for Ctrl+Shift+I (developer tools)
  //     if (e.ctrlKey && e.shiftKey && e.key === 'I') {
  //         e.preventDefault();
  //         return false;
  //     }

  //     // Check for Ctrl+Shift+J (developer tools console)
  //     if (e.ctrlKey && e.shiftKey && e.key === 'J') {
  //         e.preventDefault();
  //         return false;
  //     }

  //     // Check for Ctrl+U (view source)
  //     if (e.ctrlKey && e.key === 'u') {
  //         e.preventDefault();
  //         return false;
  //     }
  // });
  // Disable only "View Source" and "Open Console"

  // Disable certain DevTools shortcuts and right-click
  document.addEventListener('keydown', function (e) {
    const key = (e.key || '').toLowerCase();
    const ctrlOrCmd = e.ctrlKey || e.metaKey; // Ctrl (Win/Linux) or Cmd (Mac)

    // === Allow normal editing shortcuts ===
    if (ctrlOrCmd && ['c', 'x', 'v', 'a', 'z', 'y'].includes(key)) {
      return; // do nothing -> allow default behavior
    }

    // === Block F12 ===
    if (e.key === 'F12' || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }

    // === Block Ctrl/Cmd + Shift + I or J ===
    if (ctrlOrCmd && e.shiftKey && ['i', 'j'].includes(key)) {
      e.preventDefault();
      return false;
    }

    // === Block View Source ===
    if ((e.ctrlKey && !e.metaKey && key === 'u') || (e.metaKey && e.altKey && key === 'u')) {
      e.preventDefault();
      return false;
    }
  });

  // === Disable right-click context menu ===
  document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
    return false;
  });
}
